export default __webpack_public_path__ + "static/R600-8674442ded5db62c45a68bfdc9c58922.png";